import getConfig from 'next/config';

const {
  publicRuntimeConfig: {
    PORT,
    NODE_ENV,
    DOMAIN,
    BASE_API,
    JOB_TRACK_API,
    COVER_LETTERS_ENDPOINT,
    BILLING_ENDPOINT,
    DOCX_ENDPOINT,
    DISABLE_PLACES_API,
    GENDER_API_KEY,
    BLOG_ENDPOINT,
    GOOGLE_ANALYTICS_ID,
    SC_ATTR,
    BASE_API_GRAPHQL,
    SENDINBLUE_CLIENT_ID,
    ROLLBAR_CLIENT_TOKEN,
    POSTHOG_KEY,
    REVOLUT_MERCHANT_PUBLIC_KEY,
    DROPBOX_API_KEY,
    NEXTAUTH_URL,
    NEXT_PUBLIC_DEVELOPER_API_KEY,
    NEXT_PUBLIC_AUTH_BASE,
    GOOGLE_PROJECT_NUMBER,
    RAZORPAY_KEY,
    RAZOR_SANDBOX_KEY,
    REVOLUT_MERCHANT_PUBLIC_KEY_PM,
    REVOLUT_MERCHANT_PUBLIC_KEY_GP,
    PAYPAL_CLIENT_ID,
    PAYPAL_CLIENT_ID_SANDBOX,
  },
} = getConfig();

const config = {
  PORT,
  NODE_ENV,
  DOMAIN,
  BASE_API,
  JOB_TRACK_API,
  COVER_LETTERS_ENDPOINT,
  BILLING_ENDPOINT,
  DOCX_ENDPOINT,
  DISABLE_PLACES_API,
  GENDER_API_KEY,
  BLOG_ENDPOINT,
  GOOGLE_ANALYTICS_ID,
  SC_ATTR,
  BASE_API_GRAPHQL,
  SENDINBLUE_CLIENT_ID,
  ROLLBAR_CLIENT_TOKEN,
  POSTHOG_KEY,
  REVOLUT_MERCHANT_PUBLIC_KEY,
  DROPBOX_API_KEY,
  NEXTAUTH_URL,
  NEXT_PUBLIC_DEVELOPER_API_KEY,
  NEXT_PUBLIC_AUTH_BASE,
  GOOGLE_PROJECT_NUMBER,
  RAZORPAY_KEY,
  RAZOR_SANDBOX_KEY,
  REVOLUT_MERCHANT_PUBLIC_KEY_PM,
  REVOLUT_MERCHANT_PUBLIC_KEY_GP,
  PAYPAL_CLIENT_ID,
  PAYPAL_CLIENT_ID_SANDBOX,
};

export default config;
